module.exports = __webpack_public_path__ + "img/TOOLATE.6b372d27.png";